module.exports = __webpack_public_path__ + "static/media/hd-buttercup.be2cedb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-photos/hd-buttercup.jpg
// module id = 831
// module chunks = 27